import { kebabCase } from 'lodash'

import { AccessChannel } from '@marketplace-web/help-center/help-center-faq-entry-url-data'
import { HelpCenterQuestionModel } from '@marketplace-web/help-center/help-center-faq-entry-data'

import { FaqEntriesSearchResp } from '../types/faq-entries-search'

export const transformFaqEntrySearchResponse = ({
  faq_entries,
}: FaqEntriesSearchResp): Array<HelpCenterQuestionModel> | null => {
  if (!faq_entries.length) return null

  return faq_entries.map(({ id, title }) => ({
    id,
    title,
    path: `/help/${kebabCase(`${id}-${title}`)}?access_channel=${AccessChannel.HcSearch}`,
  }))
}
